import { FeatureFlag } from '../FeatureFlag';
import { z } from 'zod';

export const WidgetLabelColorSchema = z.enum(['gray', 'purple', 'blue', 'yellow', 'green', 'red', 'cyan']);
export type WidgetLabelColor = z.infer<typeof WidgetLabelColorSchema>;

export const WidgetMenuLabelSchema = z.object({
    widgetType: z.string(),
    text: z.string(),
    color: WidgetLabelColorSchema,
});
export type WidgetMenuLabel = z.infer<typeof WidgetMenuLabelSchema>;

export const WidgetMenuLabelsSchema = z.array(WidgetMenuLabelSchema);
export type WidgetMenuLabels = z.infer<typeof WidgetMenuLabelsSchema>;

export const widgetMenuLabels = new FeatureFlag<WidgetMenuLabels>({
    key: 'widget-menu-labels',
    createdOn: '2026-01-22',
    defaultValue: [],
    parseValue: (value: unknown) => {
        // Handle the case where LaunchDarkly returns [null] for an empty array, since LD default on/off JSON can't be the same value
        if (Array.isArray(value) && value.length === 1 && value[0] === null) {
            return [];
        }
        return WidgetMenuLabelsSchema.parse(value);
    },
});
